<template>
    <button @click="$emit('scrollonAnchor',scrollOnAnchor())" ref="scrollAnchor" >
        <slot></slot>
    </button>
</template>

<script>
import { thisTypeAnnotation } from '@babel/types';
import { data } from 'dom7';

    export default {
    name:"scroll-anchor",
    props:{
        anchor:{
            type: String,
            default : ''
        }
    },  
    data(){
        return {
            el : null,
            containerScroll : null,
        }
    },
    methods:{
        scrollOnAnchor(){
            console.log(this.anchor)
            this.el = this.anchor ? document.querySelector(this.anchor).offsetParent : null
        this.containerScroll = document.querySelector('#inner-content')
       return this.el.getAttribute('position') //- this.el.getAttribute('data-scroll')

        

    },
    handleScroll(){

       
        window.scrollY = calc
        console.log(window.scrollY)
        

        }
    }
    
    }
</script>

<style lang="scss" scoped>
button{
    text-transform: capitalize;
    padding:0 5px;
}
</style>